<template>
  <div class="animated fadeIn">
    <div v-if="to">
      <router-link :to="to">
        <b-card :no-body="true" class="mb-md-0">
          <b-card-body class="p-0 clearfix">
            <b-row class="no-gutters" align-v="center">
              <b-col
                :cols="iconCols ? iconCols : 3"
                :class="`bg-${variant} text-center`"
              >
                <div class="p-2">
                  <i :class="`fal fa-${faIcon}`" />
                </div>
              </b-col>
              <b-col class="px-3">
                <div v-if="text" class="h6 text-primary mb-1">{{ text }}</div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </router-link>
    </div>
    <div v-if="onClick">
      <b-card :no-body="true" class="mb-md-0 btn-link" @click="onClick">
        <b-card-body class="p-0 clearfix">
          <b-row class="no-gutters" align-v="center">
            <b-col
              :cols="iconCols ? iconCols : 3"
              :class="`bg-${variant} text-center`"
            >
              <div class="p-2">
                <i :class="`fal fa-${faIcon}`" />
              </div>
            </b-col>
            <b-col class="px-3">
              <div v-if="text" class="h6 text-primary mb-1">{{ text }}</div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "LinkTile",
  props: ["text", "faIcon", "variant", "to", "onClick", "iconCols"],
};
</script>
